//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.SystemObjectBuilder.js";
import "../Mechatronics/Mechatronics.ObjectInformationBuilder.js";
let d=[[[0,"ExampleDesc",1,0],[0,"FunctionItemRevisionId",1,1],[0,"FunctionOptionSet",1,0],[0,"LetterName",1,0],[0,"Modified",1,0],[0,"NavigatorObject",0,"NXObject",0],[1,"ObjectInformation",0,"Mechatronics.ObjectInformationBuilder",0],[0,"ObjectName",1,1],[0,"Parent",1,"NXObject",0],[0,"PlmxmlFileName",1,0],[0,"TypeDesc",1,0]],[[["numChildren","children"],"GetChildren",{},0,0],[["children"],"SetChildren",{},1,0],[["numOccurrences","occurrences"],"GetOccurrences",{},0,0],[["occurrences"],"SetOccurrences",{},1,0],[["numOperations","operations"],"GetOperations",{},0,0],[["operations"],"SetOperations",{},1,0],[["numParameterData"],"GetParameterData",{R_:{parameterData:""}},0,0],[["parameterData"],"SetParameterData",{},1,0],[["numRequirementData"],"GetRequirementData",{R_:{requirementData:""}},0,1],[["requirementData"],"SetRequirementData",{},1,1]],[]];
SPLM.Mechatronics.FunctionObjectBuilder = class extends SPLM.Mechatronics.SystemObjectBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.FunctionObjectBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.FunctionObjectBuilder.ParameterData = class{
    constructor(parameter_name,parameter_value){
        this.parameter_name=parameter_name;this.parameter_value=parameter_value;}
    get ParameterName(){return this.parameter_name}
    set ParameterName(val){this.parameter_name = val}
    get ParameterValue(){return this.parameter_value}
    set ParameterValue(val){this.parameter_value = val}
};

SPLM.Mechatronics.FunctionObjectBuilder.RequirementData = class{
    constructor(requirement_name,requirement_desc,requirement_id){
        this.requirement_name=requirement_name;this.requirement_desc=requirement_desc;this.requirement_id=requirement_id;}
    get RequirementName(){return this.requirement_name}
    set RequirementName(val){this.requirement_name = val}
    get RequirementDesc(){return this.requirement_desc}
    set RequirementDesc(val){this.requirement_desc = val}
    get RequirementId(){return this.requirement_id}
    set RequirementId(val){this.requirement_id = val}
};

export default SPLM;